import { useAuth0 } from "@auth0/auth0-react";
import { type ReactNode, useEffect, useState } from "react";
import { StompSessionProvider } from "react-stomp-hooks";

import { basePath } from "@utils/api";

type StompSessionProviderWithAuthProps = {
  children: ReactNode;
};

export default function StompSessionProviderWithAuth({
  children,
}: StompSessionProviderWithAuthProps) {
  const { isAuthenticated, getAccessTokenSilently } = useAuth0();
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    if (!isAuthenticated) return;

    const audience: string = import.meta.env.VITE_PUBLIC_AUTH0_AUDIENCE;
    const scope = "openid profile email offline_access";

    getAccessTokenSilently({ authorizationParams: { audience, scope } })
      .then(setToken)
      .catch((e) => {
        console.error("[WebSocket] Failed to get access token:", e);
      });
  }, [isAuthenticated, getAccessTokenSilently]);

  const connectHeaders =
    token != null ? { Authorization: `Bearer ${token}` } : undefined;

  return (
    <StompSessionProvider
      url={basePath + "/websocket"}
      connectHeaders={connectHeaders}
    >
      {children}
    </StompSessionProvider>
  );
}
